import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SystemService } from '../../services/system.service';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { combineLatest, Subscription, Observable, of } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { CommonPopup } from '../common-popup/common-popup';
import { map } from 'rxjs/operators';
import { DialogDelete } from 'src/app/dialog-delete/dialog-delete.component';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-site-system',
  templateUrl: './site-system.component.html',
  styleUrls: ['./site-system.component.css']
})
export class SiteSystemComponent implements OnInit {

  vmMachineArr = [];
  changeButtonState: boolean = false;
  siteId: string;
  systemId: string;
  redirect: boolean = false;
  user: User;
  cabinetsObs;
  scannerDocPath = "open_lending_doc";
  cabinets = [];
  openLending: boolean;
  openVending: boolean;
  pickuppoint: boolean;
  vmMachineChangedSub: Subscription;
  checkOpenLendingSub: Subscription;
  lockerId: string;
  combineLatestSub: Subscription;
  $machineArr: Observable<any>
  $openLendingArr: Observable<any>
  $pickupPointArr: Observable<any>
  constructor(
    private route: ActivatedRoute,
    private systemService: SystemService,
    private router: Router,
    public dialog: MatDialog,
    public auth: AuthService,
  ) {

  }

  //vm machine
  ngOnInit() {
    this.auth.user$.subscribe(user => this.user = user)

    // console.log(this.route.routeConfig.data);
    this.redirect = this.route.routeConfig.data['redirect'];

    console.log(this.route.routeConfig.data);

    combineLatest(this.route.parent.params, this.route.params, this.route.queryParams).subscribe(async (params) => {

      this.siteId = params[0]['siteId']
      this.systemId = params[1]['systemId']
      // this.lockerId = await this.systemService.getKey();
      this.systemService.systemSetData(this.siteId, this.systemId);

    })

    this.$machineArr = this.systemService.vmMachineChanged.pipe(map((doc: any[]) => {
      return doc.map(d => {
        return {
          ...d,
          uid: d['id'],
          url: `/dashboard/sites/${this.siteId}/system/${this.systemId}/vmmachine/${d['id']}`
        }
      })
    }));

    this.$openLendingArr = of([{
      name: "Open Lending",
      uid: this.scannerDocPath,
      url: `/dashboard/sites/${this.siteId}/system/${this.systemId}/openlending/open_lending_doc`
    }])

    this.$pickupPointArr = of([{
      name: "Pickup Point",
      uid: this.scannerDocPath,
      url: `/dashboard/sites/${this.siteId}/system/${this.systemId}/pickupPoint`
    }])

    this.vmMachineChangedSub = this.$machineArr.subscribe((vmArr) => {
      if (this.redirect) {
        this.router.navigate([vmArr[0].url]);
      }
      this.vmMachineArr = vmArr;
    })
  }

  test() {
    console.log('Hello');
  }

  showCabinet(index) {
    this.router.navigate(['cabinet', index], { relativeTo: this.route });
  }

  showOpenLending() {
    this.router.navigate(['openlending', this.scannerDocPath], { relativeTo: this.route });
  }

  showOpenVending() {
    this.router.navigate(['openvending'], { relativeTo: this.route });

  }


  goToStockControll() {
    this.router.navigate(['stockcontroll'], { relativeTo: this.route })
  }


  //end vm machine

  onCal8Overview() {

    this.router.navigate(['unitsoverview'], { relativeTo: this.route })

  }

  rfidLogs() {
    this.router.navigate(['rfidlogs'], { relativeTo: this.route })
  }


  addNewVM(): void {
    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        text: "",
        formData: {
          title: "Add New Machine",
          inputFeilds: [
            {
              labelName: "Machine Name",
              name: "name",
              required: true,
              type: "text",
              specialText: ""
            },

            {
              labelName: "Machine Type",
              name: "type",
              required: true,
              type: null,
              specialText: "",
              selectOptions: [
                {
                  label: "Vending Machine",
                  value: "vend"
                },
                // {
                //   label: "Locker",
                //   value: "cal8"
                // },
                // {
                //   label: "Open Vend",
                //   value: "open"
                // }
              ]
            },
            {
              labelName: "Activation Code",
              name: "code",
              required: true,
              type: "text",
              specialText: ""
            },
            {
              labelName: "USB Path",
              name: "USBPath",
              required: true,
              type: "text",
              specialText: ""
            }
          ],
          buttons: [
            {
              name: "ADD",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
      // const dialogRef = this.dialog.open(AddMachinePopup, {

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.value.type == 'cal8')
          result.value.cabinetsQuantity = 0;
        if (result.value.type == 'open')
          result.value.dummy = true;

        this.systemService.addNewVendingMachine(result.value);
      }
    });
  }






  onUpdateMachine($event) {
    let event = $event.$event;
    let id = $event.uid;
    event.stopPropagation();

    let machine = this.vmMachineArr.find(obj => obj.id === id);

    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        text: `Update ${machine.name}`,
        formData: {
          title: "Update",
          inputFeilds: [
            {
              labelName: "Machine Name",
              name: "name",
              required: true,
              value: machine.name,
              type: "text",
              specialText: ""
            },
            {
              labelName: "Index",
              name: "index",
              required: true,
              value: machine.index,
              type: "number",
              specialText: ""
            },
            {
              labelName: "Machine Type",
              name: "type",
              required: true,
              type: null,
              value: machine.type,
              specialText: "",
              selectOptions: [
                {
                  label: "Vending Machine",
                  value: "vend"
                },
                {
                  label: "Locker",
                  value: "cal8"
                },
                {
                  label: "Open Vend",
                  value: "open"
                }
              ]
            }
          ],
          buttons: [
            {
              name: "Update",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.value.index)
          result.value.index = Number(result.value.index)
        this.systemService.onUpdateMachine(id, result.value)

      }
    });
  }






  onDeleteMachine($event) {
    let event = $event.$event;
    let id = $event.uid;
    event.stopPropagation();
    const dialogRef = this.dialog.open(DialogDelete, {
      disableClose: true,
      width: '350px',
      data: {
        formData: {
          title: "DELETE",
          message: " Are you sure to continue? "
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.systemService.deleteVendingMachine(id)
      }

    });
  }

  ngOnDestroy(): void {
    // this.sub.unsubscribe();
    this.vmMachineChangedSub.unsubscribe();
    if (this.checkOpenLendingSub) this.checkOpenLendingSub.unsubscribe();
    // if (this.combineLatestSub) this.combineLatestSub.unsubscribe();
  }
}
